/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OfferType {
  ONE_MONTH_EXTENDED_SUBSCRIPTION_CANCELLATION = 'one_month_extended_subscription_cancellation',
  TWO_MONTH_EXTENDED_SUBSCRIPTION_CANCELLATION = 'two_month_extended_subscription_cancellation',
  ONE_MONTH_FREE_SUBSCRIPTION_EXTENSION = 'one_month_free_subscription_extension',
  TWO_MONTHS_FREE_SUBSCRIPTION_EXTENSION = 'two_months_free_subscription_extension',
  THREE_MONTHS_FREE_SUBSCRIPTION_EXTENSION = 'three_months_free_subscription_extension',
  ULTRA_THREE_MONTHS_FREE_SUBSCRIPTION_EXTENSION = 'ultra_three_months_free_subscription_extension',
  CS_TWO_MONTHS_FREE_SUBSCRIPTION_EXTENSION = 'cs_two_months_free_subscription_extension',
  ONE_MONTH_FREE_ULTRA_TRIAL = 'one_month_free_ultra_trial',
  THREE_MONTHS_FREE_UTRA_TRIAL = 'three_months_free_utra_trial',
  ONE_MONTH_FREE_STANDARD_TRIAL = 'one_month_free_standard_trial',
  MAX_TRIAL_OFFER = 'max_trial_offer',
  PENDING_CANCELLATION_THREE_MONTH_EXTENDED_SUBSCRIPTION_CANCELLATION = 'pending_cancellation_three_month_extended_subscription_cancellation',
}
